import React, { FC, useState, useContext, createRef, useEffect } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import Typo from '../../../Components/Typo';
import gsap from 'gsap';
import DiscNavigator from '../../../Components/DiscNavigator';
import { NavigatorWheelContext } from '../../../Contexts/NavigatorWheelContext';
import { useHistory } from 'react-router-dom';
import { uniqueId } from 'lodash';

import { CIRCULAR_NAV_RADIUS, APP_HEADER_HEIGHT } from '../../../Constants';
import StyledLabel from '../../../Components/StyledLabel';
import { useMediaQuery } from '../../../Hooks/useMediaQuery';


export interface VenziWheelSectionProps {

}




const VenziWheelSection: FC<VenziWheelSectionProps> = (props) => {
    const classes = useStyles();
    const { setCurSection, curSection, navigatorAnimation } = useContext(NavigatorWheelContext);
    const discNavigatorContainerRef = createRef<HTMLDivElement>();
    const history = useHistory();
    const { isDeviceSm } = useMediaQuery();
    const id = uniqueId('home-page-wheel-container')

    useEffect(() => {
        const el = discNavigatorContainerRef.current;
        if (!el) return;

        navigatorAnimation.setPosA({ x: el.offsetLeft, y: el.offsetTop })
        navigatorAnimation.homeEntry(`.${REVEAL_TRIGGER_CLASS}`);


        return () => navigatorAnimation.cleanupHomeEntry();
    }, [])



    return (
        <section>
            <Box id={id} className={classes.root}>
                {/* <Typo align='center' gutterBottom variant='h1'>WHAT CAN VENZI DO FOR EVENT OWNERS?</Typo> */}
                <Box id={`${id}-styled-text`}>
                    <StyledLabel weight='medium' variant='h3' align='center' text="Meet the Venzi Wheel for event organisers" />
                </Box>
                <Box width={isDeviceSm ? "100vw" : "600px"} mx="auto" my={2}>
                    <Typo id={`${id}-description-text`} align='center' variant='h6'>
                        Put together your website, manage invites &amp; registrations, onboard speakers, meeting experts, partners and sponsors, and get rich usable real time analytics. The Venzi wheel covers all.
                </Typo>
                </Box>
                <Box display='flex' flexDirection='column' alignItems='center' pt={2}>
                    <div ref={discNavigatorContainerRef} className={REVEAL_TRIGGER_CLASS}>
                    </div>
                </Box>
            </Box>
        </section>
    )
}

export const REVEAL_TRIGGER_CLASS = 'reveal-trigger-disc'

const useStyles = makeStyles<Theme, any>((theme) => ({
    root: {

        '& .reveal-trigger-disc': {
            marginTop: 20,
            marginBottom: CIRCULAR_NAV_RADIUS / 2.5,
            width: CIRCULAR_NAV_RADIUS * 2,
            height: CIRCULAR_NAV_RADIUS * 2,
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }

        }
    },
}));

export default VenziWheelSection;